import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigService {
  accessToken: any;
  appMode: any;
  userId: any;
  refershToken: any;
  private config: any;
  private _jsonURL = '../assets/project.config.json';
  project_config: any;
  api_config: any;
  accountEmail: any;
  baseURL = 'https://nodesdms.azurewebsites.net/';
  userURL = 'https://nodesdms.azurewebsites.net/authaccess/'
  constructor(private http: HttpClient) {
  }

  getJSON(url = null): Observable<any> {
    return this.http.get(url || this._jsonURL);
  }

  getProjectConfig() {
    let self = this;
    return new Promise((resolve, reject) => {
      if (self.config) {
        resolve(self.config)
      } else {
        self.getJSON().subscribe(data => {
          self.config = data[data["config"]];
          this.api_config = data;
          this.project_config = data[data["config"]];
          console.log("data config", this.project_config)
          resolve(self.config)
        },
          error => reject(error)
        );
      }
    })
  }
  getMaterialStatusData() {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getApiCall(this.project_config.materialApi).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  getApiCall(url): Observable<any> {
    return this.http.get(url);
  }
  updateMaterialStatus(id: string, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.putData(this.project_config.materialApi + id, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  createMaterialStatus(data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.postData(this.project_config.materialApi, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  loadFile(url) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getJSON(url).subscribe(data => {
        resolve(data)
      },
        error => reject(error)
      );
    })
  }

  /* * *
  * get api call
  * * */
  getJsonData(url) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getJSON(url).subscribe(data => {
        resolve(data)
      },
        error => reject(error)
      );
    })
  }

  /* * *
  * method for get Json data from server
  * * */
  pullJsonData(url, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.postData(url, data).subscribe(data => {
        resolve(data)
      },
        error => reject(error)
      );
    })
  }

  /* * *
  * method for get Json data from server
  * * */
  getNetworkData(url, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.postData(url, data).subscribe(data => {
        resolve(data)
      },
        error => reject(error)
      );
    })
  }

  /* * *
  * method for get Json data from server
  * * */
  getNetworkUserData(url) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getData(url).subscribe(data => {
        resolve(data)
      },
        error => reject(error)
      );
    })
  }

  /* * *
  * method for get Json data from server
  * * */
  addNetworkUserData(url, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.postData(url, data).subscribe(data => {
        resolve(data)
      },
        error => reject(error)
      );
    })
  }

  /* * *
  * post api call
  * * */
  getData(url): Observable<any> {
    return this.http.get(url);
  }
  postData(url, data): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(data);
    return this.http.post(url, body, { 'headers': headers })
  }
  putData(url, data): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    return this.http.put(url, data, { 'headers': headers })
  }
  deleteData(url: string): Observable<any> {
    return this.http.delete(url)
  }

  /* * * * * *
  * excel upload
  * * * * * */
  async uploadExcelData(url, formData, cbck) {
    var xhr = new XMLHttpRequest();
    var reponse = "";
    let auth = window.origin.includes("navyapp.canadacentral.cloudapp.azure.com") ? 'no' : this.api_config['authentication'];
    xhr.open('POST', url, true);
    xhr.setRequestHeader("Authorization", "Bearer " + this.accessToken);
    xhr.setRequestHeader("Authentication", auth);
    xhr.onload = function (e) {
      reponse = xhr.responseText;
      cbck(reponse);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          // alert("Excel Uploaded Successfully !!");
        } else {
          // alert("Excel Upload Falied !!");
        }
      }
    };
    xhr.send(formData);
  }
  getUserData(): Observable<any> {
    return this.http.get(this.userURL)
  }
  /* * *
    * Group API
    * * */
  getGroupListData() {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getApiCall(this.project_config.groupApi).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }

  createGroup(data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.postData(this.project_config.groupApi, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  updateGroup(id: string, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.putData(this.project_config.groupApi + id, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  deleteGroup(id: string) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.deleteData(this.project_config.groupApi + id).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }

  deleteComment(id: string) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.deleteData(this.project_config.compartmentComment + id).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  /* * *
   * Layout API
   * * */
  getLayoutData() {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getApiCall(this.project_config.layoutApi).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  getLayout(id: string) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.getApiCall(this.project_config.layoutApi + id).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  createLayout(data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.postData(this.project_config.layoutApi, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  updateLayout(id: string, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.putData(this.project_config.layoutApi + id, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  deleteTagpoint(id: string, data) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.putData(this.project_config.layoutApi + 'delete/' + id, data).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }
  deleteLayout(id: string) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.deleteData(this.project_config.layoutApi + id).subscribe(data => {
        resolve(data);
      },
        error => reject(error)
      );
    })
  }

    /* * *
   * Status API
   * * */
    getStatusData() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.getApiCall(this.project_config.statusApi).subscribe(data => {
          resolve(data);
        },
          error => reject(error)
        );
      })
    }
    getStatus(id: string) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.getApiCall(this.project_config.statusApi + id).subscribe(data => {
          resolve(data);
        },
          error => reject(error)
        );
      })
    }
    createStatus(data) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.postData(this.project_config.statusApi, data).subscribe(data => {
          resolve(data);
        },
          error => reject(error)
        );
      })
    }
    updateStatus(id: string, data) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.putData(this.project_config.statusApi + id, data).subscribe(data => {
          resolve(data);
        },
          error => reject(error)
        );
      })
    }
    deleteStatus(id: string) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.deleteData(this.project_config.statusApi + id).subscribe(data => {
          resolve(data);
        },
          error => reject(error)
        );
      })
    }

       /* * *
   * Upload API
   * * */
       postUploadData(url, data): Observable<any> {
        return this.http.post(url, data)
      }
}
